import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function CampaignOperatorGameDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"CampaignOperatorGame Details"}
                            editHref={"/campaign-gameconfig/update"}
                            endpoint={"campaign-operator-gameconfig/read"}
                            relations={["campaign", "operator_game_config"]}
                        />
}

export default CampaignOperatorGameDetailsPage;